"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CampaignDetails;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _r10SourceLibrary = require("r10-source-library");
var _DetailsHeader = _interopRequireDefault(require("./DetailsHeader"));
var _DetailsBanner = _interopRequireDefault(require("./DetailsBanner"));
var _DetailsCard = _interopRequireDefault(require("./DetailsCard"));
var _BenefitsCard = _interopRequireDefault(require("./BenefitsCard"));
var _GiftsCard = _interopRequireDefault(require("./GiftsCard"));
var _CtaButton = _interopRequireDefault(require("./CtaButton"));
var _jsonpathPlus = require("jsonpath-plus");
var _functions = require("../helpers/functions");
var _useConfig2 = _interopRequireDefault(require("../hooks/useConfig"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Container = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin: 0 auto;\n  padding: 20px;\n  max-width: ", ";\n"])), function (props) {
  var _props$maxWidth;
  return (_props$maxWidth = props.maxWidth) !== null && _props$maxWidth !== void 0 ? _props$maxWidth : '1164px';
});
function CampaignDetails(_ref) {
  var campaignDetails = _ref.campaignDetails;
  var _useConfig = (0, _useConfig2.default)(),
    _useConfig$jsonPaths = _useConfig.jsonPaths,
    _useConfig$jsonPaths2 = _useConfig$jsonPaths === void 0 ? {} : _useConfig$jsonPaths,
    titlePath = _useConfig$jsonPaths2.titlePath,
    imageUrlPath = _useConfig$jsonPaths2.imageUrlPath,
    _useConfig$widgetCust = _useConfig.widgetCustomization,
    _useConfig$widgetCust2 = _useConfig$widgetCust === void 0 ? {} : _useConfig$widgetCust,
    maxWidth = _useConfig$widgetCust2.maxWidth,
    showCtaButton = _useConfig$widgetCust2.showCtaButton;
  function getCampaignGifts() {
    if (campaignDetails !== null && campaignDetails !== []) return (0, _functions.findGiftsData)(campaignDetails);
    return {
      flag: false,
      gifts: {}
    };
  }
  var _useState = (0, _react.useState)(getCampaignGifts()),
    _useState2 = _slicedToArray(_useState, 2),
    giftData = _useState2[0],
    setGiftData = _useState2[1];
  var _JSONPath = (0, _jsonpathPlus.JSONPath)({
      path: titlePath,
      json: campaignDetails[0]
    }),
    _JSONPath2 = _slicedToArray(_JSONPath, 1),
    title = _JSONPath2[0];
  var _JSONPath3 = (0, _jsonpathPlus.JSONPath)({
      path: imageUrlPath,
      json: campaignDetails[0]
    }),
    _JSONPath4 = _slicedToArray(_JSONPath3, 1),
    imageUrl = _JSONPath4[0];
  (0, _react.useEffect)(function () {
    setGiftData(getCampaignGifts());
  }, [campaignDetails]);
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "pega-details-widget"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      bottom: 7
    }
  }, /*#__PURE__*/_react.default.createElement(_DetailsHeader.default, {
    title: title
  }), /*#__PURE__*/_react.default.createElement(_DetailsBanner.default, {
    imageUrl: imageUrl
  })), /*#__PURE__*/_react.default.createElement(Container, {
    maxWidth: maxWidth
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SimpleGrid, {
    layout: {
      sm: [12],
      md: [7, 5]
    },
    spacing: 4
  }, /*#__PURE__*/_react.default.createElement(_DetailsCard.default, {
    title: title,
    campaignDetails: campaignDetails
  }), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_BenefitsCard.default, {
    campaignDetails: campaignDetails
  }), giftData.flag && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_GiftsCard.default, {
    giftData: giftData
  })), showCtaButton && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.MatchMedia, {
    breakpoint: "md",
    andAbove: true
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_CtaButton.default, null)))))), showCtaButton && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.MatchMedia, {
    breakpoint: "sm"
  }, /*#__PURE__*/_react.default.createElement(_CtaButton.default, null)));
}
CampaignDetails.propTypes = {
  campaignDetails: _propTypes.default.array
};